import { track, userId, currentDate } from './shared';

const newsletterSubscribed = ({ email }) => {
  track({
    eventName: 's_track',
    data: {
      s_event: 'Newsletter Subscribed',
      s_properties: {
        newsletter_subscription_date: currentDate(),
        email,
        user_id: userId()
      }
    }
  });
};

export default newsletterSubscribed;
